/**
 * arbi settings          — show current user settings
 * arbi settings set      — update a setting
 */

import { Command } from 'commander'
import { settings as settingsOps } from '@arbidocs/sdk'
import { runAction, resolveAuth, parseJsonArg, printJson } from '../helpers.js'
import { success } from '../output.js'

export function registerSettingsCommand(program: Command): void {
  const settings = program.command('settings').description('User settings: get, set')

  settings
    .command('get')
    .description('Show current user settings (always JSON; --json accepted for consistency)')
    .option('--json', 'Output as JSON (default — always JSON)')
    .action(() =>
      runAction(async () => {
        const { arbi } = await resolveAuth()
        const data = await settingsOps.getSettings(arbi)
        printJson(data)
      })()
    )

  settings
    .command('set <json>')
    .description('Update user settings (pass JSON object)')
    .action((json: string) =>
      runAction(async () => {
        const body = parseJsonArg(json, 'arbi settings set \'{"hide_online_status": true}\'')
        const { arbi } = await resolveAuth()
        await settingsOps.updateSettings(arbi, body)
        success('Settings updated.')
      })()
    )

  // Default action: get
  settings.action(async () => {
    await settings.commands.find((c) => c.name() === 'get')!.parseAsync([], { from: 'user' })
  })
}
